import React, { useEffect, useState } from "react";
import { FiAlertCircle } from "react-icons/fi";

import { useAuth } from "../../../context/AuthContext";
import { linhasDe, listarExportacoesSobras } from "../../../services/suprimentos";
import { Card, ErrorMsg, Table, TableWrapper, TruncCell } from "../styles";
import { Vazio } from "../_shared/Estados";

function dataHora(iso) {
  return iso ? new Date(iso).toLocaleString("pt-BR") : "—";
}

export default function ExportacoesTab() {
  const { request } = useAuth();
  const [linhas, setLinhas] = useState([]);
  const [erro, setErro] = useState(null);

  useEffect(() => {
    listarExportacoesSobras(request)
      .then((p) => { setLinhas(linhasDe(p)); setErro(null); })
      // Erro (ex.: sem permissao) nao pode virar "nenhuma exportacao gerada".
      .catch((err) => { setLinhas([]); setErro(err?.payload?.detalhe || err?.message || "Não foi possível carregar as exportações."); });
  }, [request]);

  return (
    <Card>
      {erro ? <ErrorMsg><FiAlertCircle size={14} /> {erro}</ErrorMsg> : null}
      {erro ? null : linhas.length === 0 ? (
        <Vazio titulo="Nenhuma exportação gerada" descricao="Marque sobras disponíveis na aba Sobras e use 'Exportar para o otimizador'." />
      ) : (
        <TableWrapper>
          <Table>
            <colgroup>
              <col style={{ width: "16%" }} /><col style={{ width: "34%" }} /><col style={{ width: "10%" }} />
              <col style={{ width: "20%" }} /><col style={{ width: "20%" }} />
            </colgroup>
            <thead><tr><th>Código</th><th>Arquivo</th><th>Itens</th><th>Por</th><th>Quando</th></tr></thead>
            <tbody>
              {linhas.map((l) => (
                <tr key={l.id}>
                  <td><TruncCell>{l.codigo}</TruncCell></td>
                  <td title={l.arquivo_nome}><TruncCell>{l.arquivo_nome}</TruncCell></td>
                  <td>{l.total_itens}</td>
                  <td><TruncCell>{l.gerado_por_nome || "—"}</TruncCell></td>
                  <td>{dataHora(l.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </TableWrapper>
      )}
    </Card>
  );
}
